import { GroupService } from "@/common/api.service"
import { FETCH_GROUPS, FETCH_GROUP_USERS,FETCH_INDIVIDUAL_GROUP, ADD_GROUP, UPDATE_GROUP,RESET_STATE, DELETE_GROUP } from "./actions.type"
import { SET_GROUPS, SET_GROUP_USERS,SET_INDIVIDUAL_GROUP, SET_ERROR_GROUPS,STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        groups: [],
        individualgroup: [],
        grouperrors: null,
        groupusers: [],
    }
}

let state = initialState()

const getters = {
    groups(state) {
        return state.groups
    },
    groupusers(state) {
        return state.groupusers
    },

    individualgroup(state) {
        return state.individualgroup
    }
}

const actions = {
    async [FETCH_GROUPS](context, slug) {
        const { data } = await GroupService.get(slug)
        context.commit(SET_GROUPS, data.data)
        return data;
    },
    async [FETCH_GROUP_USERS](context, slug) {
        const { data } = await GroupService.getUser(slug)
        context.commit(SET_GROUP_USERS, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_GROUP](context, slug) {
        const { data } = await GroupService.get(slug)
        context.commit(SET_INDIVIDUAL_GROUP, data.data)
        return data;
    },  
    async [ADD_GROUP](context, payload) {
        return await GroupService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_GROUPS, error.response.data.errors)
        });
    },     
    async [UPDATE_GROUP](context, payload) {
        return await GroupService.create(payload, payload.group_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_GROUPS, error.response.data.errors)
        });
    },  
    async [DELETE_GROUP] (context, group_id) {
        return await GroupService.delete(group_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_GROUPS, error.response.data.errors)
        });
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_GROUPS](state, error) {
        state.grouperrors = error
    },      
    [SET_GROUPS](state, groupsdata) {
        state.groups = groupsdata
    },
    [SET_GROUP_USERS](state, groupuserdata) {
        state.groupusers = groupuserdata
    },

    [SET_INDIVIDUAL_GROUP](state, individualgroupdata) {
        state.individualgroup = individualgroupdata
    },    
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};